import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';

const useStyles = buildUseStyles('CapitalizeComponent', () => ({
  iframe: {
    border: 'none',
    width: '100%',
    height: '100dvh',
  },
}));

const CapitalizeComponent = ({ rel }) => {
  const classes = useStyles();

  return (
    <FDBox flexGrow={1}>
      <iframe
        id="capitalize-webview"
        title="capitalize-webview"
        src={rel.link('related').url()}
        className={classes.iframe}
      />
    </FDBox>
  );
};

CapitalizeComponent.defaultProps = {
};

CapitalizeComponent.propTypes = {
  rel: PropTypes.object.isRequired,
};

export default CapitalizeComponent;
